import { Component, Input, Output, EventEmitter, OnInit, ViewChild, ElementRef, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { VideoFeature, VideoOutputType } from 'src/app/_models/video';

@Component({
  selector: 'app-video-upload',
  templateUrl: './video-upload.component.html',
  styleUrls: ['./video-upload.component.scss']
})
export class VideoUploadComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() maxVideoSize: number;
  @Input() feature: any;
  @Output() featureChange = new EventEmitter<any>();
  @ViewChild('videoPlayer') videoPlayer: ElementRef;

  // Expose enum to template
  videoOutputTypes = VideoOutputType;
  
  // Default output type options for the SelectButton
  outputTypeOptions = [
    { label: '2D Video', value: VideoOutputType.TwoDimensional },
    { label: 'AR Video', value: VideoOutputType.AugmentedReality }
  ];

  // Track the current feature ID to detect changes
  private currentFeatureId: string;
  
  // Video element object used for forcing recreation
  videoElement = { id: 1 };

  constructor(private messageService: MessageService) {}

  ngOnInit() {
    console.log(JSON.stringify(this.feature));
    
    // Initialize output type if not set
    if (this.feature.value && !this.feature.value.outputType) {
      this.feature.value.outputType = VideoOutputType.TwoDimensional;
      this.featureChange.emit(this.feature);
    }
    
    this.currentFeatureId = this.feature.id;
  }

  ngAfterViewInit() {
    // No need to refresh video here, as it will trigger unnecessary loading
  }
  
  ngOnChanges(changes: SimpleChanges) {
    // Check if the feature has changed (different ID)
    if (changes.feature && this.feature) {
      if (this.currentFeatureId !== this.feature.id) {
        this.currentFeatureId = this.feature.id;
        this.refreshVideo();
      }
    }
  }
  
  // TrackBy function that forces NgFor to recreate the video element
  identifyVideo(index: number, item: any): number {
    return item.id;
  }
  
  refreshVideo() {
    // Create a new video element object with a unique ID to force NgFor recreation
    this.videoElement = { id: Date.now() };
  }

  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  fileBrowseHandler(files: any) {
    this.prepareFilesList(files);
  }

  prepareFilesList(files: Array<any>) {
    for (const file of files) {
      if (this.isValidFile(file)) {
        const videoFeature: VideoFeature = {
          name: file.name,
          url: URL.createObjectURL(file),
          size: file.size,
          isUploaded: false,
          type: 'video',
          file: file,
          outputType: VideoOutputType.TwoDimensional // Default value
        };
        
        this.feature.value = videoFeature;
        this.featureChange.emit(this.feature);
        
        // Refresh the video player with the new source
        this.refreshVideo();
      }
    }
  }

  onOutputTypeChange(event: any) {
    if (this.feature.value) {
      this.feature.value.outputType = event.value;
      this.featureChange.emit(this.feature);
    }
  }

  isValidFile(file: any): boolean {
    if (file.size > this.maxVideoSize) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: `Video file size exceeded ${this.maxVideoSize/1000000}MB`
      });
      return false;
    }
    if (!file.type.startsWith('video/')) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Invalid file type. Please upload a video file.'
      });
      return false;
    }
    return true;
  }

  deleteFeatureVideo() {
    this.feature.value = undefined;
    this.featureChange.emit(this.feature);
  }
  
  getVideoUrl(): string {
    if (this.feature.value?.url !== undefined && this.feature.value.url.length > 0) {
      return this.feature.value.url;
    }
    if (this.feature.value?.isUploaded) {
      return `https://firebasestorage.googleapis.com/v0/b/${environment.firebaseConfig.projectId}.appspot.com/o/${this.feature.id}%2F${encodeURIComponent(this.feature.value.name)}?alt=media`;
    }
    return '';
  }
}